import { WeatherApiResponse } from "../Contract/Weather";
import { getAuthHeaders } from "./authSession";

export const getWeather = async (): Promise<WeatherApiResponse> => {
  const res = await fetch(process.env.REACT_APP_API_ENDPOINT!, {
    method: "POST",
    headers: { "content-type": "application/json", ...getAuthHeaders() },
    body: JSON.stringify({ action: "getWeather" }),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `Weather request failed (${res.status})`);
  }

  const data = await res.json();
  // The API can answer 200 with an error body; don't let that pass as weather.
  if (!data?.location || !data?.current || !data?.forecast) {
    throw new Error(
      `Unexpected weather response: ${JSON.stringify(data).slice(0, 200)}`,
    );
  }
  return data as WeatherApiResponse;
};
